import { CSSProperties } from "react"

export type AppType = 'web' | 'android' | 'ios';
export enum AppTypeEnum {
    WEB = 'web',
    ANDROID = 'android',
    IOS = 'ios'
}

export type Language      = 'it' | 'de' | 'en'
export type Municipal     = 'merano' | 'brunico' | 'bolzano' | 'bressanone'
export type AvailableCities = Municipal
export type CharacterType = 'fashion' | 'music' | 'sport' | 'geek'

export type CharacterAccessoriesGlassesColor = '#c62319' | '#1d1d1f' | '#dfffd1' | '#ffeb3b' | '#d72f5d'
export type CharacterAccessoriesTieColor     = '#c62319' | '#ffffff' | '#dfffd1' | '#ffeb3b' | '#d72f5d'
export type CharacterGuitarColor       = '#000000' | '#999999'
export type CharacterGeekDressColor    = '#efefef' | '#FFFFFF';
export type CharacterMusicDressColor   = '#661212' | '#efefef';
export type CharacterSportDressColor   = '#222c4c' | '#009688';
export type CharacterFashionDressColor = '#ffecaf' | '#d72f5d' | '#efefef';
export type CharacterDressColor = CharacterGeekDressColor | CharacterMusicDressColor | CharacterSportDressColor | CharacterFashionDressColor;
export type CharacterPose = 'neutral' | 'think' | 'happy' | 'speak' | 'speak-tilt';
export interface Character{
    type: CharacterType
    dress_color: {
        geek?:    CharacterGeekDressColor,
        music?:   CharacterMusicDressColor,
        sport?:   CharacterSportDressColor,
        fashion?: CharacterFashionDressColor
    }
    guitar_color?: CharacterGuitarColor //For Music character
    accessories: {
        glasses_color?: CharacterAccessoriesGlassesColor //For Geek & Fashion character
        tie_color?: CharacterAccessoriesTieColor //For Geek character
        necklace?: boolean //For Fashion character

    }
}

export interface PropsSVGDog {
    style?: CSSProperties
    className?: string
    customise?: {
        color_dress?: CharacterDressColor
        color_tie?: CharacterAccessoriesTieColor
        color_glasses?: CharacterAccessoriesGlassesColor
    }
}

export interface User {
    language: Language
    municipal: Municipal
    character: Character
    interact_with_cat_type?: CharacterType
}

export interface Translate{
    Language: {
        it: string,
        en: string,
        de: string
    },

    Municipal: {
        bolzano: string,
        merano: string,
        brunico: string,
        bressanone: string
    },

    ButtonText: {
        start: string,
        next: string,
        confirm: string,
        customise: string
        cancel: string
        download: string
        try_again: string
        read_more: string
    },

    PuzzleText:{
        station4: {
            bolzano: string
            merano: string
            bressanone: string
            brunico: string
        },

        station4_sport: {
            bolzano: {title: string, text: string} 
            merano:  {title: string, text: string} 
            bressanone: {title: string, text: string} 
            brunico: {title: string, text: string} 
        },

        station5_puzzle2: string
    },

    Text: {
        select_cat_character_title: string
        found: string
        and: string
        drag_here_answer: string,
        loading: string,
        reset: string,
        retry: string,
        unableToLoadImage: string,
        checkConnectionRetry: string,
        imageLoadError: string,

    },

    ErrorText: {
        invalid_qrcode: string
    },

    CharacterDogType: {
        dog_geek: string,
        dog_music: string,
        dog_sport: string,
        dog_fashion: string
    },

}


export namespace App{
    export class Prova{
        static ciao(){

        }
    }
}


export namespace App{
    export class Ciao{
        static ciao(){

        }
    }
}